"use strict";
exports.__esModule = true;
require("../styles/main.scss");
// Va caricato sempre in cima altrimenti non possono esserne utilizzate le funzioni
require("./utils");
// Globals
require("./global");
// Header scripts
/* layout */
require("./layout");
/* components */
require("./components");
